import { InboxOutlined } from "@ant-design/icons";
import type { ReactNode } from "react";

interface EmptyStateProps {
	title: string;
	description?: string;
	icon?: ReactNode;
	action?: ReactNode;
}

export function EmptyState({ title, description, icon, action }: EmptyStateProps) {
	return (
		<div className="flex flex-col items-center justify-center px-6 py-14 text-center">
			<span className="mb-4 flex size-11 items-center justify-center rounded-xl bg-[var(--c-hover)] text-lg text-[var(--c-text-muted)]">
				{icon ?? <InboxOutlined />}
			</span>
			<div className="text-sm font-medium text-[var(--c-text)]">{title}</div>
			{description ? (
				<div className="mt-1 max-w-xs text-[13px] text-[var(--c-text-secondary)]">
					{description}
				</div>
			) : null}
			{action ? <div className="mt-4">{action}</div> : null}
		</div>
	);
}
